// Income Type Mutations

export const updateIncomeTypeList = (state, payload) => {
  state.incomeTypeList = payload
}

export const fetchIncomeTypeInfo = (state, payload) => {
  state.incomeTypeInfo = payload
}

export const setFullIncomeTypesList = (state, payload) => {
  state.fullIncomeTypesList = payload
}
